import { defineComponent, ref, createElementBlock, openBlock, normalizeClass, createElementVNode, renderSlot } from 'vue';
import { useIntersectionObserver } from './basler-components.es417.js';
import e from './basler-components.es432.js';

const _hoisted_1 = { class: "scroll-box__content-edge-left" };
const _hoisted_2 = { class: "scroll-box__content-edge-right" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ScrollBox",
  emits: ["visibilityChange"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const componentRoot = ref(null);
    const contentContainer = ref(null);
    const edgeLeft = ref(null);
    const edgeLeftIsVisible = ref(true);
    const edgeRight = ref(null);
    const edgeRightIsVisible = ref(true);
    useIntersectionObserver(
      edgeLeft,
      ([{ isIntersecting }]) => {
        edgeLeftIsVisible.value = isIntersecting;
        emit("visibilityChange", {
          edgeLeftIsVisible: edgeLeftIsVisible.value,
          edgeRightIsVisible: edgeRightIsVisible.value
        });
      },
      { root: componentRoot }
    );
    useIntersectionObserver(
      edgeRight,
      ([{ isIntersecting }]) => {
        edgeRightIsVisible.value = isIntersecting;
        emit("visibilityChange", {
          edgeLeftIsVisible: edgeLeftIsVisible.value,
          edgeRightIsVisible: edgeRightIsVisible.value
        });
      },
      { root: componentRoot }
    );
    const scrollContentIntoView = (direction) => {
      if (contentContainer.value) {
        const contentElement = contentContainer.value.querySelector("*:nth-child(2)");
        if (contentElement) {
          e(contentElement, {
            behavior: "smooth",
            inline: direction,
            scrollMode: "if-needed",
            boundary: contentContainer.value
          });
        }
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([
          "scroll-box",
          {
            "is-overflowing-left": !edgeLeftIsVisible.value,
            "is-overflowing-right": !edgeRightIsVisible.value
          }
        ]),
        ref_key: "componentRoot",
        ref: componentRoot
      }, [
        createElementVNode("div", {
          class: "scroll-box__content",
          ref_key: "contentContainer",
          ref: contentContainer
        }, [
          createElementVNode("div", _hoisted_1, [
            createElementVNode("div", {
              class: "scroll-box__content-edge-left-ref",
              ref_key: "edgeLeft",
              ref: edgeLeft
            }, null, 512)
          ]),
          renderSlot(_ctx.$slots, "default"),
          createElementVNode("div", _hoisted_2, [
            createElementVNode("div", {
              class: "scroll-box__content-edge-right-ref",
              ref_key: "edgeRight",
              ref: edgeRight
            }, null, 512)
          ])
        ], 512),
        _cache[2] || (_cache[2] = createElementVNode("div", { class: "scroll-box__shadow-left" }, null, -1)),
        _cache[3] || (_cache[3] = createElementVNode("div", { class: "scroll-box__shadow-right" }, null, -1)),
        createElementVNode("button", {
          class: "scroll-box__btn-left",
          onClick: _cache[0] || (_cache[0] = ($event) => scrollContentIntoView("start")),
          "aria-label": "Scroll to the start of the content",
          type: "button"
        }),
        createElementVNode("button", {
          class: "scroll-box__btn-right",
          onClick: _cache[1] || (_cache[1] = ($event) => scrollContentIntoView("end")),
          "aria-label": "Scroll to the end of the content",
          type: "button"
        })
      ], 2);
    };
  }
});

export { _sfc_main as default };
